export { CookieConsent, useConsent } from "./consent";
import * as _gtm from "./gtm";
export { _gtm as gtm };
